import { useEffect, useState } from "react";

/**
 * Theme-Store (hell/dunkel) ohne Context: die Wahrheit ist die `dark`-Klasse
 * auf <html>, gesetzt vom Init-Script in index.html (vor dem ersten Paint,
 * kein Flash). Header (Desktop) und MobileNav-Sheet schalten beide hierüber,
 * damit sie nie auseinanderlaufen.
 */
const STORAGE_KEY = "leif-theme";
const THEME_COLOR = { light: "#ffffff", dark: "#0b1214" } as const;

const listeners = new Set<() => void>();

function isDark(): boolean {
  return typeof document !== "undefined" && document.documentElement.classList.contains("dark");
}

/** Theme global setzen, persistieren und alle useTheme()-Nutzer wecken. */
export function setDark(dark: boolean): void {
  document.documentElement.classList.toggle("dark", dark);
  try {
    localStorage.setItem(STORAGE_KEY, dark ? "dark" : "light");
  } catch {
    // privater Modus / Storage blockiert — dann eben nur für diese Sitzung
  }
  // Statusleisten-Farbe der installierten PWA mitziehen.
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", dark ? THEME_COLOR.dark : THEME_COLOR.light);
  listeners.forEach((l) => l());
}

export function useTheme(): { dark: boolean; toggle: () => void } {
  const [dark, set] = useState(isDark);
  useEffect(() => {
    const l = () => set(isDark());
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  return { dark, toggle: () => setDark(!isDark()) };
}
